module.exports = __webpack_public_path__ + "static/media/manager-r-3.8a88c883.png";